import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import Reveal, { SectionLabel, ease } from "./Reveal";
import { GOOGLE_URL } from "@/lib/scroll";

const REVIEWS = [
  { src: "img/review-threads.png", alt: "Avaliação de alessandrastella1104 no Threads" },
  { src: "img/review-decassantos.png", alt: "Avaliação de decassantos no Threads" },
  { src: "img/review-erica.png", alt: "Avaliação de erica_berillo no Threads" },
  { src: "img/review-daysantos263.png", alt: "Avaliação de daysantos263 no Threads" },
  { src: "img/review-sonia.png", alt: "Avaliação de Sonia Andrade no Google" },
];

export default function Depoimentos() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const lenis = window.__lenis;
    if (active) {
      lenis?.stop();
      const onKey = (e) => e.key === "Escape" && setActive(null);
      window.addEventListener("keydown", onKey);
      return () => {
        lenis?.start();
        window.removeEventListener("keydown", onKey);
      };
    }
  }, [active]);

  return (
    <section id="depoimentos" className="bg-cream pb-28 md:pb-36 pt-4">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10">
        <SectionLabel n="06">Depoimentos</SectionLabel>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-3xl font-display font-medium text-[clamp(2rem,4.2vw,3.6rem)] leading-[1.08] tracking-[-0.01em]">
            O que meus pacientes estão <em className="font-serifd italic text-terra">falando</em>{" "}
            sobre mim
          </h2>
        </Reveal>

        <div className="mt-14 columns-1 gap-5 sm:columns-2 lg:columns-3" data-testid="depoimentos-grid">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.src} delay={0.06 * i} y={22} className="mb-5 break-inside-avoid">
              <button
                onClick={() => setActive(r)}
                data-testid={`depoimento-print-${i + 1}`}
                aria-label={`Ampliar ${r.alt}`}
                className="block w-full cursor-zoom-in overflow-hidden rounded-2xl shadow-lg shadow-olive/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-terra"
              >
                <img src={r.src} alt={r.alt} className="h-auto w-full" loading="lazy" />
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="depoimentos-google-link"
            className="mt-6 inline-block text-lg font-semibold text-terra underline decoration-terra/40 underline-offset-8 transition hover:decoration-terra"
          >
            Ver avaliações no Google →
          </a>
        </Reveal>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            data-testid="depoimento-lightbox"
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[95] grid cursor-zoom-out place-items-center bg-olive-deep/90 p-5 backdrop-blur-sm"
          >
            <motion.img
              initial={{ scale: 0.92, y: 16 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.95, y: 8 }}
              transition={{ duration: 0.35, ease }}
              src={active.src}
              alt={`${active.alt} (ampliada)`}
              className="max-h-[85vh] max-w-[92vw] rounded-2xl shadow-2xl"
            />
            <button
              onClick={(e) => {
                e.stopPropagation();
                setActive(null);
              }}
              data-testid="lightbox-close"
              aria-label="Fechar imagem ampliada"
              className="absolute right-5 top-5 inline-flex size-11 items-center justify-center rounded-full border border-cream/30 text-cream transition hover:bg-cream/10"
            >
              <X className="size-5" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
